import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Protected from "@/components/Protected";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import ShopSignup from "@/pages/ShopSignup";
import AdvertiserSignup from "@/pages/AdvertiserSignup";
import ShopDashboard from "@/pages/ShopDashboard";
import AdvertiserDashboard from "@/pages/AdvertiserDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentResult from "@/pages/PaymentResult";
import ShopSetup from "@/pages/ShopSetup";
import ZoneClaim from "@/pages/ZoneClaim";
import ApplicationStatus from "@/pages/ApplicationStatus";
import CardSaved from "@/pages/CardSaved";
import PublicPreview from "@/pages/PublicPreview";
import RiderHome from "@/pages/RiderHome";
import RiderBikePathDetail from "@/pages/RiderBikePathDetail";
import ExplorePage from "@/pages/ExplorePage";
import PrintQRSheet from "@/pages/PrintQRSheet";
import AssistantWidget from "@/components/AssistantWidget";
import "@/index.css";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) return null;
  if (!user) return <Landing />;
  const home = user.role === "admin" ? "/admin" : user.role === "shop" ? "/shop" : "/advertiser";
  return <Navigate to={home} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/signup/shop" element={<ShopSignup />} />
          <Route path="/signup/advertiser" element={<AdvertiserSignup />} />
          <Route path="/pay/setup" element={<ShopSetup />} />
          <Route path="/application-status" element={<ApplicationStatus />} />
          <Route path="/preview/bike-path/:pathId" element={<PublicPreview />} />
          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/rider" element={<RiderHome />} />
          <Route path="/rider/bike-path/:id" element={<RiderBikePathDetail />} />
          <Route path="/shop" element={<Protected roles={["shop"]}><ShopDashboard /></Protected>} />
          <Route path="/claim-zone" element={<Protected roles={["shop"]}><ZoneClaim /></Protected>} />
          <Route path="/advertiser" element={<Protected roles={["advertiser"]}><AdvertiserDashboard /></Protected>} />
          <Route path="/advertiser/card-saved" element={<Protected roles={["advertiser"]}><CardSaved /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
          <Route path="/admin/print-qr/:pathId" element={<Protected roles={["admin"]}><PrintQRSheet /></Protected>} />
          <Route path="/payment/success" element={<Protected roles={["advertiser"]}><PaymentResult success /></Protected>} />
          <Route path="/payment/cancel" element={<Protected roles={["advertiser"]}><PaymentResult success={false} /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <AssistantWidget />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
